<style>
  .uk-container.main-container {
    /*margin-top: 100px !important;*/
    background-color: #ffffff !important
    }
    body {
      /*background-color: #ecf0f1 !important*/
    }
  html, body, h1, h2, h3, h4, h5, p, span, a {
    font-family: "Trebuchet MS", Helvetica, sans-serif !important;
  }
</style>


<template>
  <navigation></navigation>
  <div class="">
    <!--Router view, inside a global container and under the global nav-->
    <router-view></router-view>
  </div>
  <foot></foot>
</template>

<script>
  import Navigation from './Nav.vue'
  import Foot from './Footer.vue'

  export default {
    name: 'AppView',
    components: {
      Navigation,
      Foot
    },
    events: {
      'selected-farm': function(farm) {
        console.log('Farms just sent me an event')
        this.$root.$broadcast('this-farm', farm)
        console.log('I just sent an event to all my children')

      }
    }
  }
</script>


/** WEBPACK FOOTER **
 ** App.vue?9a137bd6
 **/